import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import type { UnitFeature } from "@/types";

interface UnitTableFeatureFilterProps {
    features: UnitFeature[];
    selectedFeatures: number[];
    onSelectionChange: (features: number[]) => void;
}

export const UnitTableFeatureFilter = ({
    features,
    selectedFeatures,
    onSelectionChange,
}: UnitTableFeatureFilterProps) => {
    const handleCheckBoxChange = (feature: number) => {
        const newFeatures = selectedFeatures.includes(feature)
            ? selectedFeatures.filter((f) => f !== feature)
            : [...selectedFeatures, feature];
        onSelectionChange(newFeatures);
    };

    return features.length > 0 ? (
        <div>
            <p className="tw:font-bold">By Feature</p>
            <div className="tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:gap-x-4">
                {features.map((feature) => (
                    <div
                        key={feature.id}
                        className="tw:items-start tw:flex-row tw:flex tw:space-x-3 tw:space-y-0 tw:py-1"
                    >
                        <Checkbox
                            id={feature.slug}
                            onCheckedChange={() => handleCheckBoxChange(feature.id)}
                            checked={selectedFeatures.includes(feature.id)}
                        />
                        <Label
                            htmlFor={feature.slug}
                            className="tw:text-sm tw:font-normal tw:ml-2"
                        >
                            {feature.name}
                        </Label>
                    </div>
                ))}
            </div>
        </div>
    ) : null;
};
